import A11yDialog from 'a11y-dialog';
import { toggleDialogState } from '../../../js/utils';

export default class SwaCountryFeedbackDialog {

  constructor(
    globalDialogLanguageCountry = 'swa-header-country-feedback-dialog',
    dialogCountry = 'swa-header-country-nav-dialog',
  ){
    this.globalDialogLanguageCountry = globalDialogLanguageCountry;
    this.globalDialogCountryLanguageElement = document.querySelector(`#${this.globalDialogLanguageCountry}`);
    this.dialogCountry = dialogCountry;
    this.countryDialogElement = document.querySelector(`#${this.dialogCountry}`);
  }

  init() {
    const styleOverlay = { open: 'swa-dialog-open'};

    if (!this.globalDialogCountryLanguageElement) {
      return;
    }

    window.globalFeedbackDialogCountry = this.globalDialogCountryLanguageElement
      ? new A11yDialog(this.globalDialogCountryLanguageElement)
      : null;

    globalFeedbackDialogCountry.on('show', () => {
      toggleDialogState(`#${this.globalDialogLanguageCountry}`, true);
      this.globalDialogCountryLanguageElement.classList.toggle(styleOverlay.open);
      // close the main dialog when globalCountryLanguageSelectorDialog gets shown
      if (this.countryDialogElement) {
        globalCountryDialogInst.hide();
      }
    });

    globalFeedbackDialogCountry.on('hide', () => {
      toggleDialogState(`#${this.globalDialogLanguageCountry}`, false);
      this.globalDialogCountryLanguageElement.classList.toggle(styleOverlay.open);
    });
  }
}
